export enum TravelQuestionEnum {
  TransportForms = 'Czym będziesz podróżować?',
  TransportFormsPlural = 'Czym będziecie podróżować?',
}
